import React from 'react'
import './Elem3SaveDraft.css'

const Elem3SaveDraft = ({onClick}) => {
    return (
        <div className='saveDraft'>
            <button onClick={onClick} className="SaveDraft-container">
                <span class="material-symbols-outlined" style={{marginRight:'10px'}}>
                    Bookmark
                </span>
                Save Draft
            </button>    
        </div>
    )
}

export default Elem3SaveDraft;
